import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter040() {
  return <KbChapterPage slug="chapter-040" />;
}

(Chapter040 as unknown as { path: string }).path = "/theory-album/040";
